import {useEffect} from 'react';

export function useDefaultFavicon() {
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link');

    link.rel = 'icon';
    link.href = '/default-favicon.ico';
    document.head.appendChild(link);

    return () => {
      link.href = `/${import.meta.env.VITE_COMPANY_NAME}/favicon.ico`;
    };
  }, []);
}
